module.exports = __webpack_public_path__ + "static/media/md-musical-note.acd6f29a.svg";